import './styles.scss';
import { DailyWheelModal } from "./components/claim-promo-modal/DailyWheelModal";
import { DailyWheelButton } from "./components/daily-wheel-button/DailyWheelButton";
import { NewFortuneWheelModal } from "./components/NewFortuneWheelModal/NewFortuneWheelModal";
import { fortuneWheelStore } from "../../../platform/stores";
import { observer } from "mobx-react";

export const DailyWheel = observer(() => {
  return (
    <div className="daily-wheel-wr">
      <DailyWheelButton/>
      <NewFortuneWheelModal/>
      {fortuneWheelStore.dailyWheelModalIsOpen && (<DailyWheelModal/>)}
    </div>
  );
});